import {getAccessAdministrationUserAccess} from "@project/sdk/access-administration";
import {GetAccessAdministrationUserAccessResponse} from "@project/sdk/access-administration/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {userAccessKeys} from "../../access-administration-keys";

export function getUserAccessQueryOptions(userId: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: userAccessKeys.detail(userId),
    queryFn: async ({signal}) =>
      GetAccessAdministrationUserAccessResponse.parse(
        await getAccessAdministrationUserAccess(userId, {signal}),
      ),
  });
}
